import React, { useState } from "react";
import { FaShare, FaCopy, FaEnvelope, FaPrint, FaX } from "react-icons/fa6";
import Snackbar from "@mui/material/Snackbar";

// If you have a specific link to share, you can pass it via props (e.g. as `shareUrl`).
// For this example, we'll just use window.location.href to demonstrate.

const ShareBox = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // State to manage Snackbar visibility
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(prev => !prev);
  };

  // 1. Copy Link
  const handleCopyLink = () => {
    const currentLink = window.location.href;
    navigator.clipboard
      .writeText(currentLink)
      .then(() => {
        // Show the Snackbar
        setSnackbarOpen(true);
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  };

  // 2. Email Link
  const handleEmailLink = () => {
    const currentLink = window.location.href;
    const subject = encodeURIComponent("Check this out!");
    const body = encodeURIComponent(`I found this interesting: ${currentLink}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  // 3. Print Page
  const handlePrintPage = () => {
    window.print();
  };

  // 4. Native Share (Android, iOS, etc.) — using the Web Share API if supported
  const handleNativeShare = async () => {
    const currentLink = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: "Found something interesting to share:",
          url: currentLink
        });
      } catch (err) {
        console.error("Error using native share: ", err);
      }
    } else {
      alert("Native share isn't supported in this browser.");
    }
  };

  // Handle closing the Snackbar (fired by autoHideDuration or user manually closing)
  const handleSnackbarClose = (event, reason) => {
    // If user clicks outside or otherwise tries to close
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <div className="w-full md:w-[200px] flex justify-end shrink-0 print:hidden">
      {/* This is the main share button */}
      <button onClick={toggleModal} className="border border-primaryBlue rounded-md p-2 flex items-center text-lg text-primaryBlue">
        <FaShare className="mr-2" />
        Share / Print
      </button>

      {/* Our modal, visible only when `isModalOpen` is true */}
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center print:hidden z-40" onClick={toggleModal}>
          {/* Stop propagation to prevent closing when clicking inside the box */}
          <div className="bg-white p-4 rounded-md shadow-lg z-50 w-full print:hidden max-w-[400px]" onClick={e => e.stopPropagation()}>
            <h3 className="text-2xl font-semibold text-secondaryColor mb-4 border-b pb-2">Share This Page</h3>
            <button onClick={handleCopyLink} className="border border-primaryBlue rounded-md p-2 mt-4 w-full flex justify-start items-center text-primaryBlue hover:bg-primaryBlue/10">
              <FaCopy className="mr-2 " />
              Copy Link
            </button>
            <button onClick={handleEmailLink} className="border border-primaryBlue rounded-md p-2 mt-4 w-full flex justify-start items-center text-primaryBlue hover:bg-primaryBlue/10">
              <FaEnvelope className="mr-2 " />
              Email Link
            </button>
            <button onClick={handlePrintPage} className="border border-primaryBlue rounded-md p-2 mt-4 w-full flex justify-start items-center text-primaryBlue hover:bg-primaryBlue/10">
              <FaPrint className="mr-2 " />
              Print Page
            </button>
            <button onClick={handleNativeShare} className="border border-primaryBlue rounded-md p-2 mt-4 w-full flex justify-start items-center text-primaryBlue hover:bg-primaryBlue/10">
              <FaShare className="mr-2 " />
              More Share Options
            </button>
            <button onClick={toggleModal} className="border border-primaryBlue rounded-md p-2 mt-4 w-1/2 flex justify-center items-center text-primaryBlue hover:bg-primaryBlue/10 ml-auto">
              <FaX className="mr-2 text-red-500" />
              Close
            </button>
          </div>
        </div>
      )}

      {/* Material UI Snackbar for "Link copied" confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000} // Closes after 2 seconds
        onClose={handleSnackbarClose}
        message="Link copied to clipboard!"
        ContentProps={{
          sx: {
            backgroundColor: "#009999",
            color: "#fff"
          }
        }}
      />
    </div>
  );
};

export default ShareBox;
